import { request, getBaseUrl, sessionFetch } from './http';

export async function getFields() {
    return request('/fields');
  }

export async function createField(payload) {
    return request('/fields', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateField(id, payload) {
    return request(`/fields/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function getWells(params = {}) {
    const query = new URLSearchParams();
    if (params.FieldID) query.append('FieldID', params.FieldID);
    if (params.FieldIDs && Array.isArray(params.FieldIDs) && params.FieldIDs.length > 0) {
      query.append('FieldIDs', params.FieldIDs.join(','));
    }
    const qs = query.toString();
    return request(`/wells${qs ? `?${qs}` : ''}`);
  }

export async function createWell(payload) {
    return request('/wells', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateWell(id, payload) {
    return request(`/wells/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function getComplianceOrders(params = {}) {
    const query = new URLSearchParams();
    if (params.FieldID) query.append('FieldID', params.FieldID);
    if (params.Status) query.append('Status', params.Status);
    if (params.DNRVisitRequired !== undefined) {
      query.append('DNRVisitRequired', params.DNRVisitRequired ? 'true' : 'false');
    }
    const qs = query.toString();
    return request(`/compliance-orders${qs ? `?${qs}` : ''}`);
  }

export async function getConocoTasks() {
    return request('/conoco-tasks');
  }

export async function getConocoTask(id) {
    return request(`/conoco-tasks/${id}`);
  }

export async function createConocoTask(payload) {
    return request('/conoco-tasks', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateConocoTask(id, payload) {
    return request(`/conoco-tasks/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function deleteConocoTask(id) {
    return request(`/conoco-tasks/${id}`, {
      method: 'DELETE'
    });
  }

export async function getTodos() {
    return request('/todos');
  }

export async function createTodo(payload) {
    return request('/todos', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateTodo(id, payload) {
    return request(`/todos/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function deleteTodo(id) {
    return request(`/todos/${id}`, {
      method: 'DELETE'
    });
  }

export async function getTodoAssignedRecords() {
    return request('/todos/assigned-records');
  }

export async function getAccountableAssignees(tableName, recordId) {
    const params = new URLSearchParams({
      tableName: String(tableName || ''),
      recordId: String(recordId || '')
    });
    return request(`/todos/accountable-assignees?${params.toString()}`);
  }

export async function assignTodoToAccountable(payload) {
    return request('/todos/assign-to-accountable', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function getConocoTaskGroups() {
    return request('/conoco-task-groups');
  }

export async function getConocoTaskGroup(id) {
    return request(`/conoco-task-groups/${id}`);
  }

export async function createConocoTaskGroup(payload) {
    return request('/conoco-task-groups', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateConocoTaskGroup(id, payload) {
    return request(`/conoco-task-groups/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function deleteConocoTaskGroup(id) {
    return request(`/conoco-task-groups/${id}`, {
      method: 'DELETE'
    });
  }

export async function getConocoTaskTemplates(groupId) {
    return request(`/conoco-task-groups/${groupId}/templates`);
  }

export async function createConocoTaskTemplate(groupId, payload) {
    return request(`/conoco-task-groups/${groupId}/templates`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateConocoTaskTemplate(groupId, templateId, payload) {
    return request(`/conoco-task-groups/${groupId}/templates/${templateId}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function deleteConocoTaskTemplate(groupId, templateId) {
    return request(`/conoco-task-groups/${groupId}/templates/${templateId}`, {
      method: 'DELETE'
    });
  }

export async function getComplianceOrdersReport(params = {}) {
    const query = new URLSearchParams();
    if (params.companyId == null || params.companyId === '') {
      throw new Error('companyId is required for compliance orders report');
    }
    query.append('companyId', String(params.companyId));
    query.append('view', params.view === 'verifications' ? 'verifications' : 'orders');
    const appendCsv = (key, val) => {
      if (val == null) return;
      const arr = Array.isArray(val) ? val : [val];
      const s = arr.filter(Boolean).join(',');
      if (s) query.append(key, s);
    };
    appendCsv('wellIds', params.wellIds);
    appendCsv('companyScopeIds', params.companyScopeIds);
    appendCsv('fieldIds', params.fieldIds);
    appendCsv('responsibleChartIds', params.responsibleChartIds);
    appendCsv('accountableChartIds', params.accountableChartIds);
    appendCsv('consultChartIds', params.consultChartIds);
    appendCsv('informChartIds', params.informChartIds);
    appendCsv('orderTypes', params.orderTypes);
    appendCsv('actionCodes', params.actionCodes);
    appendCsv('workTypes', params.workTypes);
    appendCsv('rankings', params.rankings);
    appendCsv('orderStatuses', params.orderStatuses);
    appendCsv('verificationStatuses', params.verificationStatuses);
    if (params.dueFrom) query.append('dueFrom', params.dueFrom);
    if (params.dueTo) query.append('dueTo', params.dueTo);
    if (params.companyName) query.append('companyName', String(params.companyName));
    if (params.verifSubmittedFrom) query.append('verifSubmittedFrom', params.verifSubmittedFrom);
    if (params.verifSubmittedTo) query.append('verifSubmittedTo', params.verifSubmittedTo);
    if (params.penalty === true || params.penalty === false) {
      query.append('penalty', params.penalty ? 'true' : 'false');
    }
    // Prevent stale 304 cache responses on report endpoints.
    query.append('_ts', String(Date.now()));
    return request(`/compliance-orders/report?${query.toString()}`);
  }

export async function getPendingComplianceOrderVerifications() {
    return request('/compliance-orders/pending-verifications');
  }

export async function getComplianceOrder(id) {
    return request(`/compliance-orders/${id}`);
  }

export async function getComplianceOrderWorkTypes() {
    return request('/compliance-orders/work-types');
  }

export async function getComplianceOrderActionCodes() {
    return request('/compliance-orders/action-codes');
  }

export async function getComplianceOrderActionCodesReference() {
    return request('/compliance-orders/reference/action-codes');
  }

export async function createComplianceOrderActionCode(data) {
    return request('/compliance-orders/reference/action-codes', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateComplianceOrderActionCode(id, data) {
    return request(`/compliance-orders/reference/action-codes/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteComplianceOrderActionCode(id) {
    return request(`/compliance-orders/reference/action-codes/${id}`, {
      method: 'DELETE',
    });
  }

export async function getComplianceOrderWorkTypesReference() {
    return request('/compliance-orders/reference/work-types');
  }

export async function createComplianceOrderWorkType(data) {
    return request('/compliance-orders/reference/work-types', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

export async function updateComplianceOrderWorkType(id, data) {
    return request(`/compliance-orders/reference/work-types/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

export async function deleteComplianceOrderWorkType(id) {
    return request(`/compliance-orders/reference/work-types/${id}`, {
      method: 'DELETE',
    });
  }

export async function createComplianceOrder(payload) {
    return request('/compliance-orders', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function updateComplianceOrder(id, payload) {
    return request(`/compliance-orders/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    });
  }

export async function deleteComplianceOrder(id) {
    return request(`/compliance-orders/${id}`, {
      method: 'DELETE'
    });
  }

export async function addComplianceOrderActionLog(id, notes, logDate = null) {
    return request(`/compliance-orders/${id}/action-logs`, {
      method: 'POST',
      body: JSON.stringify({ Notes: notes, CreatedDate: logDate })
    });
  }

export async function getComplianceOrderActionLogs(id) {
    return request(`/compliance-orders/${id}/action-logs`);
  }

export async function updateComplianceOrderActionLog(orderId, logId, notes, logDate = null) {
    return request(`/compliance-orders/${orderId}/action-logs/${logId}`, {
      method: 'PUT',
      body: JSON.stringify({ Notes: notes, CreatedDate: logDate })
    });
  }

export async function deleteComplianceOrderActionLog(orderId, logId) {
    return request(`/compliance-orders/${orderId}/action-logs/${logId}`, {
      method: 'DELETE'
    });
  }

export async function submitComplianceOrder(id, payload) {
    return request(`/compliance-orders/${id}/submit`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function getComplianceOrderStateAttachments(id) {
    return request(`/compliance-orders/${id}/state-attachments`);
  }

export async function addComplianceOrderStateAttachment(id, payload) {
    return request(`/compliance-orders/${id}/state-attachments`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function deleteComplianceOrderStateAttachment(id, attachmentId) {
    return request(`/compliance-orders/${id}/state-attachments/${attachmentId}`, {
      method: 'DELETE'
    });
  }

export async function getComplianceOrderInspectionReportAttachments(id) {
    return request(`/compliance-orders/${id}/inspection-report-attachments`);
  }

export async function addComplianceOrderInspectionReportAttachment(id, payload) {
    return request(`/compliance-orders/${id}/inspection-report-attachments`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function deleteComplianceOrderInspectionReportAttachment(id, attachmentId) {
    return request(`/compliance-orders/${id}/inspection-report-attachments/${attachmentId}`, {
      method: 'DELETE'
    });
  }

export async function getComplianceOrderPhotoAttachments(id) {
    return request(`/compliance-orders/${id}/photo-attachments`);
  }

export async function addComplianceOrderPhotoAttachment(id, payload) {
    return request(`/compliance-orders/${id}/photo-attachments`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function deleteComplianceOrderPhotoAttachment(id, attachmentId) {
    return request(`/compliance-orders/${id}/photo-attachments/${attachmentId}`, {
      method: 'DELETE'
    });
  }

export async function setComplianceOrderVerificationSubmittalLetter(verificationId, payload) {
    return request(`/compliance-order-verifications/${verificationId}/submittal-letter`, {
      method: 'PUT',
      body: JSON.stringify(payload || {})
    });
  }

export async function clearComplianceOrderVerificationSubmittalLetter(verificationId) {
    return request(`/compliance-order-verifications/${verificationId}/submittal-letter`, {
      method: 'DELETE'
    });
  }

export async function rejectComplianceOrderVerification(id, payload) {
    return request(`/compliance-order-verifications/${id}/reject`, {
      method: 'PUT',
      body: JSON.stringify(payload || {})
    });
  }

export async function submitComplianceOrderVerificationToState(id) {
    return request(`/compliance-order-verifications/${id}/submit-to-state`, {
      method: 'PUT'
    });
  }

export async function closeComplianceOrderVerification(id) {
    return request(`/compliance-order-verifications/${id}/close`, {
      method: 'PUT'
    });
  }

export async function setComplianceOrderVerificationDnr(id, flag) {
    return request(`/compliance-order-verifications/${id}/dnr`, {
      method: 'PUT',
      body: JSON.stringify({ DNRVisitRequired: !!flag })
    });
  }

export async function updateComplianceOrderVerification(id, payload) {
    return request(`/compliance-order-verifications/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload || {})
    });
  }

export async function deleteComplianceOrderVerification(id) {
    return request(`/compliance-order-verifications/${id}`, {
      method: 'DELETE'
    });
  }

export async function runAllNotificationChecks() {
    return request('/notifications/run-all-checks', {
      method: 'POST',
    });
  }

export async function getComplianceDigest(userId) {
    return request(`/notifications/compliance-digest-data/${userId}`);
  }

export async function sendComplianceDigest(userId, testEmail = null) {
    return request(`/notifications/send-compliance-digest/${userId}`, {
      method: 'POST',
      body: JSON.stringify({ testEmail }),
    });
  }

export async function getProjectStatusReportData(projectId, frequency) {
    const query = new URLSearchParams();
    if (frequency) query.set('frequency', String(frequency));
    const qs = query.toString();
    return request(`/notifications/project-status-report-data/${projectId}${qs ? `?${qs}` : ''}`);
  }

export async function sendProjectStatusReport(projectId, payload = {}) {
    return request(`/notifications/send-project-status-report/${projectId}`, {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    });
  }

export async function getProjectStatusReportSetup(projectId) {
    return request(`/projects/${projectId}/status-report-setup`);
  }

export async function updateProjectStatusReportSetup(projectId, payload = {}) {
    return request(`/projects/${projectId}/status-report-setup`, {
      method: 'PUT',
      body: JSON.stringify(payload || {}),
    });
  }

export async function sendProjectStatusReportNow(projectId, payload = {}) {
    return request(`/projects/${projectId}/status-report-send`, {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    });
  }

export async function downloadProjectStatusReportLatest(projectId) {
    return downloadBinaryFile(
      `/projects/${projectId}/status-report-latest`,
      'status-report.zip'
    );
  }

export async function downloadProjectStatusReportDraft(projectId) {
    return downloadBinaryFile(
      `/projects/${projectId}/status-report-draft`,
      'status-report-draft.zip'
    );
  }

export async function downloadBinaryFile(endpoint, fallbackFilename) {
    const response = await sessionFetch(`${getBaseUrl()}/api${endpoint}`, {
      method: 'GET'
    });
    if (!response.ok) {
      let message = `Download failed (${response.status})`;
      try {
        const data = await response.json();
        message = data.message || message;
      } catch {
        /* ignore */
      }
      throw new Error(message);
    }
    const blob = await response.blob();
    let downloadFilename = fallbackFilename;
    const contentDisposition = response.headers.get('Content-Disposition');
    if (contentDisposition) {
      const quoted = contentDisposition.match(/filename="([^"]+)"/);
      const plain = contentDisposition.match(/filename=([^;]+)/i);
      if (quoted) downloadFilename = quoted[1];
      else if (plain) downloadFilename = plain[1].trim().replace(/^["']|["']$/g, '');
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = downloadFilename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return { success: true };
  }

export async function getComplianceOrderDigest(userId) {
    return request(`/notifications/compliance-order-digest-data/${userId}`);
  }

export async function sendComplianceOrderDigest(userId, testEmail = null) {
    return request(`/notifications/send-compliance-order-digest/${userId}`, {
      method: 'POST',
      body: JSON.stringify({ testEmail }),
    });
  }

export async function getComplianceOrderMonthlyReport(companyId, params = {}) {
    const query = new URLSearchParams();
    if (params.year != null && params.year !== '') query.set('year', String(params.year));
    if (params.monthIndex != null && params.monthIndex !== '') query.set('monthIndex', String(params.monthIndex));
    const qs = query.toString();
    return request(`/notifications/compliance-order-monthly-report-data/${companyId}${qs ? `?${qs}` : ''}`);
  }

export async function getComplianceOrderMonthlyReportProductionPreview(params = {}) {
    const query = new URLSearchParams();
    if (params.year != null && params.year !== '') query.set('year', String(params.year));
    if (params.monthIndex != null && params.monthIndex !== '') query.set('monthIndex', String(params.monthIndex));
    const qs = query.toString();
    return request(`/notifications/compliance-order-monthly-report-production-preview${qs ? `?${qs}` : ''}`);
  }

export async function sendComplianceOrderMonthlyReport(companyId, payload = {}) {
    return request(`/notifications/send-compliance-order-monthly-report/${companyId}`, {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    });
  }

export async function sendComplianceOrderMonthlyReportProduction(payload = {}) {
    return request('/notifications/send-compliance-order-monthly-report-production', {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    });
  }

export async function testComplianceOrderEmail(payload) {
    return request('/notifications/test-compliance-order-email', {
      method: 'POST',
      body: JSON.stringify(payload || {}),
    });
  }

export async function testComplianceAlert(userId, testEmail) {
    return request(`/notifications/test-compliance-alert/${userId}`, {
      method: 'POST',
      body: JSON.stringify({ testEmail }),
    });
  }

export const complianceOrderManagementApi = {
  getFields,
  createField,
  updateField,
  getWells,
  createWell,
  updateWell,
  getComplianceOrders,
  getConocoTasks,
  getConocoTask,
  createConocoTask,
  updateConocoTask,
  deleteConocoTask,
  getTodos,
  createTodo,
  updateTodo,
  deleteTodo,
  getTodoAssignedRecords,
  getAccountableAssignees,
  assignTodoToAccountable,
  getConocoTaskGroups,
  getConocoTaskGroup,
  createConocoTaskGroup,
  updateConocoTaskGroup,
  deleteConocoTaskGroup,
  getConocoTaskTemplates,
  createConocoTaskTemplate,
  updateConocoTaskTemplate,
  deleteConocoTaskTemplate,
  getComplianceOrdersReport,
  getPendingComplianceOrderVerifications,
  getComplianceOrder,
  getComplianceOrderWorkTypes,
  getComplianceOrderActionCodes,
  getComplianceOrderActionCodesReference,
  createComplianceOrderActionCode,
  updateComplianceOrderActionCode,
  deleteComplianceOrderActionCode,
  getComplianceOrderWorkTypesReference,
  createComplianceOrderWorkType,
  updateComplianceOrderWorkType,
  deleteComplianceOrderWorkType,
  createComplianceOrder,
  updateComplianceOrder,
  deleteComplianceOrder,
  addComplianceOrderActionLog,
  getComplianceOrderActionLogs,
  updateComplianceOrderActionLog,
  deleteComplianceOrderActionLog,
  submitComplianceOrder,
  getComplianceOrderStateAttachments,
  addComplianceOrderStateAttachment,
  deleteComplianceOrderStateAttachment,
  getComplianceOrderInspectionReportAttachments,
  addComplianceOrderInspectionReportAttachment,
  deleteComplianceOrderInspectionReportAttachment,
  getComplianceOrderPhotoAttachments,
  addComplianceOrderPhotoAttachment,
  deleteComplianceOrderPhotoAttachment,
  setComplianceOrderVerificationSubmittalLetter,
  clearComplianceOrderVerificationSubmittalLetter,
  rejectComplianceOrderVerification,
  submitComplianceOrderVerificationToState,
  closeComplianceOrderVerification,
  setComplianceOrderVerificationDnr,
  updateComplianceOrderVerification,
  deleteComplianceOrderVerification,
  runAllNotificationChecks,
  getComplianceDigest,
  sendComplianceDigest,
  getProjectStatusReportData,
  sendProjectStatusReport,
  getProjectStatusReportSetup,
  updateProjectStatusReportSetup,
  sendProjectStatusReportNow,
  downloadProjectStatusReportLatest,
  downloadProjectStatusReportDraft,
  downloadBinaryFile,
  getComplianceOrderDigest,
  sendComplianceOrderDigest,
  getComplianceOrderMonthlyReport,
  getComplianceOrderMonthlyReportProductionPreview,
  sendComplianceOrderMonthlyReport,
  sendComplianceOrderMonthlyReportProduction,
  testComplianceOrderEmail,
  testComplianceAlert,
};

